// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"a7b796e2","125":"325cd7cd","496":"c8bc0447","498":"89b9a3fa","513":"8a241c23","703":"a35881c5"}[chunkId] + ".chunk.js";
};